import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
    ActivatedRoute,
    Router,
    RouterLink,
    RouterLinkActive,
    RouterModule,
    RouterOutlet,
} from '@angular/router';
import { HeaderComponent } from '../header/header.component';

import { MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule, DOCUMENT, NgOptimizedImage } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from '../service/auth.service';

@Component({
    selector: 'app-setbtngovbr',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        MatSidenavModule,
    ],
    templateUrl: './setbtngovbr.component.html',
    styleUrl: './setbtngovbr.component.scss',
})
export class SetBtnGovBrComponent  implements OnInit {
    inativo: boolean | null | undefined
    public TentativasLogin = 0;
    constructor(private router: Router,  private authService: AuthService, private route: ActivatedRoute){}

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            let statusCibernet = params['statusCibernet'];
            if (statusCibernet != undefined)
                this.setStatusCiberArk(statusCibernet);
        });
    }

    setStatusCiberArk(statusCibernet: boolean): void {
        if (statusCibernet != undefined) {
            this.authService.setStatusCiberArk(statusCibernet).subscribe(
                (response) => {
                    this.router.navigate(['/iniciar']);
                },
                (error) => {
                    console.error('Erro ao excluir o item:', error);
                    alert("erro ao tentar alterar o status do cibernet");
                    this.router.navigate(['/iniciar']);
                }
            );
        }
    }
}
